import { createContext } from 'react';
import { Platform } from './Platforms';

export default createContext([Platform.MVX, (() => {}) as any]);
